
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            showDialog: Boolean,
            itemToDeleteId: String,
            itemToDeleteName: String,
            additionalInfo: String,
        },
        data() {
            return {
                showDelete: false,
            }
        },
        created() {
            this.showDelete = this.showDialog;
        },
        watch: {
            showDialog: {
                handler() {
                    this.showDelete = this.showDialog;
                },
                deep: true,
            },
            showDelete: {
                handler() {
                    if (!this.showDelete) {
                        this.emitResult(false);
                    }
                },
                deep: true,
            },
        },
        methods: {
            async emitResult(deleteItem: boolean) {
                this.$emit('dialogResult', deleteItem ? this.itemToDeleteId : undefined)
            },
        },
    });
